import steps from './initValues/stepper.values'

const initialState = {
    state: null,
    steps,
    stateCloseValidator: null,
    stateCloseFunction: null
}

export default (state = initialState, {type, payload}) => {
    switch (type) {

        case 'SET_STEPPER_STATE':
            return {
                ...state,
                stateCloseValidator: null,
                state: payload,
            }

        case 'SET_STEPPER_STATE_CLOSE_VALIDATOR':
            return {
                ...state,
                stateCloseValidator: payload
            }

        case 'SET_STEPPER_STATE_DEL_FORM_DRAFT_FUNCTION':
            return {
                ...state,
                deleteFormDraftFunc: payload
            }

        case 'SET_STEPPER_STATE_SAVE_FORM_DRAFT_FUNCTION':
			return {
				...state,
				saveFormDraftFunc: payload
			}

        default:
            return state
    }
}
